// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__R5qUO","consentsList":"PatientConsents_consentsList__356Us","consentsListEmpty":"PatientConsents_consentsListEmpty__O5XgM"};